<script lang="ts">
	import { browser } from "$app/environment";
	import { onMount } from "svelte";

	export let meta: Record<string, any>[];

	onMount(() => {
		if (browser) {
			const title = meta.find(m => m.title)?.title;	
			if (title) document.title = title;
		}
	})
</script>


{#if meta}
	{#each meta as props, i}
		{#if 'title' in props}
			<title>{props.title}</title>
		{:else}
			<meta {...props} />
		{/if}
	{/each}
{/if}
